export const SERIES_DATA = [
  {
    id: "bar-stool",
    title: "Bar Stool Series",
    folder: "Bar Stool Series",
    description:
      "Modern bar stools for commercial spaces, perfect for cafes and restaurants",
    models: [
      {
        productId: "K- 601",
        name: "Steel Bar Stool Chair (Black)",
        color: "Black",
        adjustable: "Yes",
        backSupport: "Yes",
        footRest: "Yes",
      },
      {
        productId: "K- 602",
        name: "Adjustable Height Bar Stool Chairs",
        color: "Black",
        adjustable: "Yes",
        backSupport: "Yes",
        footRest: "Yes",
      },
      {
        productId: "K- 603",
        name: "Leatherette Bar Stool",
        color: "Black",
        adjustable: "Yes",
        backSupport: "Yes",
        footRest: "Yes",
      },
      {
        productId: "K- 604",
        name: "Revolving Leather Bar Stool",
        color: "Red",
        adjustable: "Yes",
        backSupport: "Yes",
        footRest: "Yes",
      },
      {
        productId: "K- 605",
        name: "Curvy Plus Bar Stoo",
        color: "Grey",
        adjustable: "Yes",
        backSupport: "Yes",
        footRest: "Yes",
      },
      {
        productId: "K- 606",
        name: "PU Leather Adjustable Revolving Bar Chair",
        color: "Back",
        adjustable: "Yes",
        backSupport: "Yes",
        footRest: "Yes",
      },
      {
        productId: "K- 607",
        name: "Adjustable Bar Stool with Cushion Seat",
        color: "Black",
        adjustable: "No",
        backSupport: "No",
      },
      {
        productId: "K- 608",
        name: "Revolving Cushioned Bar Stool",
        color: "Charcoal",
        adjustable: "Yes",
        backSupport: "No",
      },
      {
        productId: "K- 609",
        name: "Eco Bar Stool",
        color: "Red",
        adjustable: "No",
        backSupport: "Yes",
      },
      {
        productId: "K- 610",
        name: "Leather Cushion Steel Chair Without Armrest",
        color: "Oak",
        adjustable: "No",
        backSupport: "Yes",
      },
      {
        productId: "K- 611",
        name: "Multipurpose Stool with Cushion seat",
        color: "Black",
        adjustable: "No",
        backSupport: "No",
      },
      {
        productId: "K- 612",
        name: "Yard Stool with Cushion seat",
        color: "Black",
        adjustable: "No",
        backSupport: "No",
      },
      {
        productId: "K- 613",
        name: "Plastic Steel Stool",
        color: "Red",
        adjustable: "No",
        backSupport: "No",
      },
    ],
  },
  {
    id: "cafeteria",
    title: "Cafeteria Series",
    folder: "Cafeteria Series",
    description:
      "Durable and stylish furniture solutions for high-traffic cafeteria environments",
    models: [
      {
        productId: "K- 701",
        name: "Comfortable Multi Purpose with a Leather Cushion Steel Chair",
        color: "Beige",
      },
      {
        productId: "K- 702",
        name: "Stacking Comfortable Multi Purpose Indoor Outdoor Cafeteria Arm Less Leather Cushion Steel Chair",
        color: "Black",
      },
      {
        productId: "K- 703",
        name: "Decent Chrome Finish Visitor/Study Chair| Leatherette Fabric Metal Dining Chair",
        color: "Black",
      },
      {
        productId: "K- 704",
        name: "Multi Purpose Indoor Outdoor Cafeteria Arm Less Leather Cushion Steel Chair with Back Support",
        color: "lack",
      },
      {
        productId: "K- 705",
        name: "Crome Steel Comfortable Dining Desk Chair",
        color: "Black",
      },
      {
        productId: "K- 706",
        name: "Well Comfortable Multi Purpose with A Leather Cushion Steel Chair",
        color: "Black",
      },
      {
        productId: "K- 707",
        name: "Metal Dining Chair with Cushioned Seat",
        color: "Red",
      },
      {
        productId: "K- 708",
        name: "Stacking Multi Purpose Canteen Steel Chair with a Leather Cushion ",
        color: "Black",
      },
      {
        productId: "K- 709",
        name: "Trapezoidal Back Stacking Banquet Chair with Gold Steel Frame",
        color: "Vinyl",
      },
      {
        productId: "K- 710",
        name: "6 Seater Rectangular Restaurant Dining Table",
        color: "Oak",
      },
      {
        productId: "K- 711",
        name: "4 Seater Rectangular Restaurant Dining Table",
        color: "Oak",
      },
      {
        productId: "K- 712",
        name: "Wooden Top Round Metal Base Chrome Finish Café Table Solid Wood Cafeteria Table",
        color: "Biege",
      },
      {
        productId: "K- 713",
        name: "Wood Top Work Table with Galvanized Base",
        color: "Oak",
      },
      {
        productId: "K- 714",
        name: "Coffee Table Café Restaurant Table in Stainless Steel & Square Glass Top",
        color: "Glass Top",
      },
      {
        productId: "K- 715",
        name: "Sturdy Glass 4 Seater Dining Table with Glass Top",
        color: "Silver",
      },
    ],
  },
  {
    id: "cyber",
    title: "Cyber Series",
    folder: "Cyber Series",
    description:
      "Contemporary designs with tech-inspired aesthetics for modern offices",
    models: [
      {
        productId: "K- 401",
        name: "Black PU With Net Tepstric High Back Office Chair",
        color: "Black",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 402",
        name: "Modern Seating Cyber Chair",
        color: "Black",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 403",
        name: "Adjustable Steel Rolling Chair",
        color: "",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 404",
        name: "Premium Chair with luxurious Leatherette Upholstery",
        color: "Brown",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 405",
        name: "Black Office / Study Chair Leatherette Office Executive Chair",
        color: "Black, Brown",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 406",
        name: "Mesh Office Executive Cyber Chair",
        color: "Black",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 407",
        name: "Durable Office Computer Mid-Back Central tilt Adjustable revolving Chair",
        color: "Black",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 408",
        name: "Eclipse Mid Back Ergonomic Cushion Office Study Computer",
        color: "Red",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
      {
        productId: "K- 409",
        name: "Adjustable Office with tilt-adjustment Cyber Chair ",
        color: "Brown",
        revolving: "Yes",
        adjustable: "Yes",
        armrest: "Yes",
      },
    ],
  },
  {
    id: "director",
    title: "Director Series",
    folder: "Director Series",
    description:
      "Executive furniture for leadership spaces with premium materials",
    models: [
      {
        productId: "K- 101",
        name: "Leatherette Office Conference Chair",
        color: "Coffee, Biege",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K-102",
        name: "Oakcraft Velor Ergo Luxury Leatherette Office Executive Chair",
        color: "Tan, Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 103",
        name: "Leather Black Low Back Revolving Office Chair",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 104",
        name: "Leatherette Office Chair with Aluminium Base",
        color: "Black",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 105",
        name: "High Back Boss Chair with Leatherette Revolving Chair ",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 106",
        name: "Brown Reveloving Office Premium Chair",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 107",
        name: "Premium immortal Fabric Office Adjustable Arm Chair",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 108",
        name: "High Back Director Office Chair with Chrome Base",
        color: "Black",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 109",
        name: "Impression Furniture High Back Letherite Revolving Chair Type-IV for Home & Office",
        color: "Tan, Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
    ],
  },
  {
    id: "dressing",
    title: "Dressing Series",
    folder: "Dressing Series",
    description:
      "Elegant dressing solutions for hospitality and personal spaces",
    models: [
      {
        productId: "K- 901",
        name: "Engineered Wood Dressing Table  (Finish Color - , WHITE, Pre-assembled)",
        mirror: "Yes",
      },
      {
        productId: "K- 902",
        name: "Engineered Wood Furniture Dressing Table Mirror Glossy PU Polish Paint Finish. Engineered Wood Dressing Table  (Finish Color - , Brown, Pre-assembled)",
        mirror: "Yes",
      },
      {
        productId: "K- 903",
        name: "Engineered Wood Dressing Table  (Finish Color - , Brown, Pre-assembled)",
        mirror: "Yes",
      },
      {
        productId: "K- 904",
        name: "Engineered Wood White Wooden Dressing Table",
        mirror: "Yes",
      },
      {
        productId: "K- 905",
        name: "Glass Dressing Table  (Finish Color - , brown, DIY(Do-It-Yourself))",
        mirror: "Yes",
      },
      {
        productId: "K- 906",
        name: "Generic Modern Wooden Makeup Vanity Dressing Table",
        mirror: "Yes",
      },
      {
        productId: "K- 907",
        name: "Solid Wood Dressing Mirror for Bedroom, Wooden Decorative Unique Mirror with Stand for Home & Hotels, PU Polish Paint Wood, Glossy Finish (White)",
        mirror: "Yes",
      },
      {
        productId: "K- 908",
        name: "Teak Borad Dressing Table with Storage",
        mirror: "Yes",
      },
      {
        productId: "K- 909",
        name: "Brown Dressing Table With Mirror with multi Storage Spaces",
        mirror: "Yes",
      },
      {
        productId: "K- 910",
        name: "Vintage Style Dressing Mirror Cabinet with Shelves, Pink and Brown,| (D16)",
        mirror: "Yes",
      },
    ],
  },
  {
    id: "executive",
    title: "Executive Series",
    folder: "Executive Series",
    description: "Premium executive furniture for corporate leadership offices",
    models: [
      {
        productId: "K- 201",
        name: "Brown Leatherette High Back Executive Chair",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 202",
        name: "High-Back Swivel Computer Office Chair with Armrests, Ergonomic Leatherette-Padded Desk Chair",
        color: "Tan Coffee",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 203",
        name: "Leather High Back Revolving Chair, For Office",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 204",
        name: "High-Back Office Chair Upholstery Leatherette & Wooden Frame Director & Executive Chair Height Adjustable Armrest Chair WheelBase ",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "k- 206",
        name: "Back Office Black Color Atrificial Leather Chair(Size: Medium)",
        color: "Black, Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 205",
        name: "Leatherette Office Executive Chair  (Black, Optional Installation Available)",

        color: "",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "k- 207",
        name: "High Back Ergonomic Cushioned Office Chair with Arm Rest and Rolling Wheels (Black)",
        color: "Brown, Black",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 208",
        name: " High-Back Imported Bonded Leather Home & Office Ergonomic Chair with High Comfort Seating",
        color: "Maroon, Black, Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 209",
        name: "Office Adjustable Arm Chair Leatherette Adjustable Seat Height",
        color: "Black",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 210",
        name: "Medium Back REVOLVING Chair with Arm and revolving and Adjustable Seat",
        color: "Black",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 211",
        name: "Fabric Executive Chair, Adjustable Seat Office use Perfect Chair",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 212",
        name: "Medium Revolving Adjustable Chair",
        color: "Cream, Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 213",
        name: "Medium Chair with Arm for Office use",
        color: "Cream, Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
      {
        productId: "K- 214",
        name: "Executive High Back Revolving Office Chair with Color Options, Integrated Lumbar Support with Comfortable Seating",
        color: "Brown",
        adjustable: "Yes",
        revolvable: "Yes",
        recliner: "Yes",
      },
    ],
  },
  {
    id: "mesh",
    title: "Mesh Series",
    folder: "Meh Series",
    description: "Minimalist designs with exceptional comfort for everyday use",
    models: [
      {
        productId: "K- 301",
        name: "Fabric Study Arm Chair",
        color: "Black",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
      {
        productId: "K- 302",
        name: "Revolving Mesh Office Chair with Seat Height Adjustment (Medium)",
        color: "Beige",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
      {
        productId: "K- 303",
        name: "Revolving Mesh Office Chair with Seat Height Adjustment (Large)",
        color: "Beige",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
      {
        productId: "K- 304",
        name: "Smart Medium Mesh Back Chair Black",
        color: "Black",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
      {
        productId: "K- 305",
        name: "Office Chair Computer Task Executive Revolving Conference Visitor Chair",
        color: "Black",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
      {
        productId: "K- 306",
        name: "Premimum Mesh Office Executive Chair with HEadrest",
        color: "Black",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
      {
        productId: "K- 307",
        name: "Pan Back Office Chair in Black Fabric and Nylon Base with pp arms",
        color: "Black",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
      {
        productId: "K- 308",
        name: "Black Mesh Mid Back Revolving | Ergonomic | Home & Office| Mesh Office Executive Chair",
        color: "Black",
        adjustable: "Yes",
        ArmRest: "Yes",
        Revolving: "Yes",
      },
    ],
  },
  {
    id: "office-table",
    title: "Office Table Series",
    folder: "Office Table Series",
    description:
      "Versatile table solutions for modern collaborative workspaces",
    models: [
      {
        productId: "K- 1001",
        name: "Wood Office Table",
        color: "Dark Brown",
      },
      {
        productId: "K- 1002",
        name: "Study Table by Zorin in Walnut Finish",
        color: "Walnut Brown",
      },
      {
        productId: "K- 1003",
        name: "Polished Plain Wood Office Table, Shape : Rectangular",
        color: "Brown",
      },
      { productId: "K- 1004", name: "Executive Table", color: "Brown" },
      {
        productId: "K- 1005",
        name: "5 Shelves Mild Steel Office Almirah",
        color: "Silver",
      },
      {
        productId: "K- 1006",
        name: "School Book Almirah with 4 Shelves",
        color: "",
      },
      { productId: "K- 1007", name: "4 Stage Luggage Rack", color: "Silver" },
      {
        productId: "K- 1008",
        name: "8 Person Metal Postal Locker",
        color: "Orange-White",
      },
      {
        productId: "K- 1009",
        name: "Black Painted Iron Three Seater Waiting Chair",
        color: "Black",
      },
      {
        productId: "K- 1010",
        name: "Silver Painted Iron Three Seater Waiting Chair",
        color: "Silver",
      },
      {
        productId: "K- 1011",
        name: "Office Conference Table",
        color: "Dark Brown",
      },
      {
        productId: "K- 1012",
        name: "2 level Bunk Be for Students/kids",
        color: "Green",
      },
      {
        productId: "K- 1013",
        name: "Rectangular Stainless Steel Office Table",
        color: "Silver Color",
      },
      {
        productId: "K- 1014",
        name: "Office Table for Home décor Brown Color Standard Size",
        color: "Brown",
      },
      {
        productId: "K- 1015",
        name: "Office Table Brown Color Large Size",
        color: "Brown",
      },
    ],
  },
  {
    id: "student",
    title: "Student Series",
    folder: "Student Series",
    description: "Ergonomic and durable furniture for educational institutions",
    models: [
      {
        productId: "K- 801",
        name: "Metal 2 Seater School Desk Bench with individual Chairs ",
        color: "Grey, Yellow",
      },
      {
        productId: "K- 802",
        name: "Wooden School Podium ",
        color: "Brown ",
      },
      {
        productId: "K- 803",
        name: "Engineering wood made 2 Seater School Desk Bench",
        color: "Biege",
      },
      {
        productId: "K- 804",
        name: "Student Writing Pad Chair",
        color: "Biege",
      },
      {
        productId: "K- 805",
        name: "Metal Single School Desck Bench with Storage",
        color: "Silver - Black",
      },
      {
        productId: "K- 806",
        name: "Plastic Single School Desck Bench with Storage",
        color: "Blue",
      },
    ],
  },
  {
    id: "visitor",
    title: "Visitor Series",
    folder: "Visitor Series",
    description:
      "Comfortable seating solutions for reception and waiting areas",
    models: [
      {
        productId: "K- 501",
        name: "Voom Net & Metal White Mesh Visitor Chair",
        color: "White",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 502",
        name: "Visitor chair with cushioned Seating for home office Metal Dining Chair",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 503",
        name: "Visitor Chair with Metal Base",
        color: "Green Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 504",
        name: "Medium Back Visitor Chair",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 505",
        name: "Steel Without Arms Visitor/Study Chair",
        color: "Black",
        backSupport: "Yes",
        armRest: "No",
      },
      {
        productId: "K- 506",
        name: "Armrest Visitor Chair with Metal Base",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 507",
        name: "Office Visitors Chairs for Office/Visitors Use",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 508",
        name: "Office Visitors Chairs with Long Back Support and Arms",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 509",
        name: "Visitor Chair for Home hotel Steel Frame and Leather seat Without arm Chair Metal Dining Chair ",
        color: "Black",
        backSupport: "Yes",
        armRest: "No",
      },
      {
        productId: "K- 510",
        name: "Mild Steel Armless Chair",
        color: "Black",
        backSupport: "Yes",
        armRest: "No",
      },
      {
        productId: "K- 511",
        name: "Leatherette Brown Visitor Chair with Padded Seating",
        color: "Brown",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 512",
        name: "Polished Black Steecl CHairt with Cushioned Seat Padded Arms",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 513",
        name: "Steel Visitor Chair Leatherette Office Visitor Chair",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
      {
        productId: "K- 514",
        name: "Visitor Chair with Arms/Staff Chair/Office Chair/Study Chair/Computer Chair/Chair with Arms",
        color: "Black",
        backSupport: "Yes",
        armRest: "Yes",
      },
    ],
  },
  {
    id: "hospital",
    title: "Hospital Series",
    folder: "Hospital Series",
    description:
      "Comfortable seating solutions for reception and waiting areas",
    models: [
      {
        productId: "3 Fold Bedside Folding Screen",
        dimensions:
          "Length - 8 feet (Big partition - 4 feet, small partition - 2 feet * 2 quantity), Height 5.4 feet.",
        description: [
          "Framework made up of CRC square pipe 20mm pipe.",
          "Frame Type - foldable 8 feet to 4 feet",
          "Moveable Heavy duty Hinges in each partition for movement",
          "No. of castors - 6pcs, size 2inch.",
        ],
      },
      {
        productId: "Examination Table",
        dimensions: "72 inch (length) * 22 inch (width) * 32 inch (height)",
        description: [
          "Framework of Examination Table made up of square MS Pspe 32 mm * thickness",
          "Body section mounted on rubber shoes",
          "Two section with adjustable backrest",
          "Cushioned top and Mattress with Rexene cover, 2 inch thickness.",
          "Mattress Mounted on wooden Board fixed with Examination table.",
          "Leg support pipe below the examination base frame.",
          "Weighing capacity up to 123 kg",
          "It has one sliding drawer and one cabinet for storage system",
          "Rexene cover Blue or Black color.",
          "Paint finish epoxy powder coated off white color.",
        ],
      },
      {
        productId: "Foot Step",
        dimensions: "18 inch(length) * 10 inch Width * 10 inch",
        description: [
          "Foot Step mande up of 25mm square pipe",
          "Moulded CRC Sheet on top of Foot Step",
          "Weight Capacity up to 180 kgs",
          "Rubber Shoe 4pcs on each leg",
          "Epoxy powder Coated",
          "Leg support between the pipe",
        ],
      },
      {
        productId: "Steel Plain Table",
        dimensions: "3 feet (length) * 2 feet (width)",
        description: [
          "Specification - Parameter Value",
          "Material -  Mild Steel",
          "Paint - Powder Coating",
          "Table Top Material - Plywood/MDF",
        ],
      },
    ],
  },
];
export const POPULAR_PRODUCTS = [
  {
    seriesId: "director",
    productId: "K- 105",
    views: 1250,
    rating: 4.8,
    orders: 87,
  },
  {
    seriesId: "cyber",
    productId: "K- 401",
    views: 980,
    rating: 4.7,
    orders: 76,
  },
  {
    seriesId: "cafeteria",
    productId: "K- 701",
    views: 870,
    rating: 4.6,
    orders: 68,
  },
  {
    seriesId: "bar-stool",
    productId: "K- 601",
    views: 760,
    rating: 4.5,
    orders: 59,
  },
  {
    seriesId: "executive",
    productId: "K- 201",
    views: 720,
    rating: 4.7,
    orders: 63,
  },
  {
    seriesId: "visitor",
    productId: "K- 501",
    views: 690,
    rating: 4.4,
    orders: 54,
  },
];

export const TOP_RATED_PRODUCTS = [
  {
    seriesId: "director",
    productId: "K- 105",
    rating: 4.9,
    reviews: 42,
    reviewExcerpt:
      "The perfect executive chair for our boardroom. Clients always compliment the professional look.",
    reviewer: "Corporate Solutions Pvt. Ltd.",
  },
  {
    seriesId: "cyber",
    productId: "K- 401",
    rating: 4.8,
    reviews: 38,
    reviewExcerpt:
      "Our IT team loves these chairs - comfortable for long coding sessions and looks futuristic.",
    reviewer: "TechNova Solutions",
  },
  {
    seriesId: "cafeteria",
    productId: "K- 701",
    rating: 4.7,
    reviews: 35,
    reviewExcerpt:
      "Sturdy and easy to clean. Perfect for our employee cafeteria that serves 200+ daily.",
    reviewer: "FoodServe Hospitality",
  },
];
